module.exports = __webpack_public_path__ + "img/Imagenes_icono_kia_exp.fa81d1cc.png";